import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

function Footer({ theme = "light" }) {
  const [year, setYear] = useState();

  useEffect(() => {
    const dateYear = new Date().getFullYear();
    setYear(dateYear);
  }, []);

  let logo =
    require("../images/rhoimpact/rhoimpact_logo-horizontal_color.png").default;
  let footerTextColor = "text-gray-600 hover:text-gray-900";
  let footerBgColor = "bg-rhoOffWhite-100";
  let footerHRColor = "border-gray-200";
  if (theme === "dark") {
    logo =
      require("../images/rhoimpact/rhoimpact_logo-horizontal_white.png").default;
    footerTextColor = "text-gray-100 hover:text-gray-300";
    footerBgColor = "bg-slate-800";
    footerHRColor = "border-gray-200";
  }

  const [email, setEmail] = useState("");
  const [newsletterMessage, setNewsletterMessage] = useState("");
  const [newsletterMessageColor, setNewsletterMessageColor] =
    useState("text-green-600");

  const onSubmit = async (event) => {
    event.preventDefault();

    // Basic email validation
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      setNewsletterMessage("Please enter a valid email address.");
      setNewsletterMessageColor("text-red-600");
      return;
    }

    const siteBaseUrl =
      process.env.GATSBY_SITE_BASE_URL || "https://rhoimpact.com";
    const functionUrl = `${siteBaseUrl}/.netlify/functions/submitToCIO`;

    const data = {
      email: email,
      form_id: "rho-impact-newsletter-v2",
      form_location: "footerNewsletter",
    };

    fetch(functionUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          setNewsletterMessage(
            `Thank you for subscribing! You will receive email to: ${email}`
          );
          setNewsletterMessageColor("text-green-600");
          setEmail(""); // Clear the email input after successful submission
        } else {
          setNewsletterMessage(
            "There was an issue subscribing you. Please try again later."
          );
          setNewsletterMessageColor("text-red-600");
        }
      })
      .catch((error) => {
        console.error("Failed to send newsletter request:", error);
        setNewsletterMessage("There was an error submitting your request.");
        setNewsletterMessageColor("text-red-600");
      });
  };
  return (
    <footer className={`${footerBgColor}`}>
      <div className="max-w-6xl px-4 mx-auto sm:px-6">
        {/* Top area: Blocks */}
        <div
          className={`grid gap-8 py-8 border-t ${footerHRColor} sm:grid-cols-12 md:py-12`}
        >
          {/* 1st block */}
          <div className="sm:col-span-12 lg:col-span-3">
            <div className="mb-2">
              {/* Logo */}
              <Link to="/" className="inline-block" aria-label="Rho Impact">
                <img
                  className="h-auto max-w-full mx-auto md:max-w-none"
                  src={logo}
                  width="250"
                  alt="Rho Impact Logo"
                />
              </Link>
            </div>
            <div className="text-sm">
              <Link
                to="/privacy-policy/"
                className={`${footerTextColor} transition duration-150 ease-in-out hover:underline`}
              >
                Privacy Policy
              </Link>{" "}
              ·{" "}
              <Link
                to="/terms-of-service/"
                className={`${footerTextColor} transition duration-150 ease-in-out hover:underline`}
              >
                Terms
              </Link>
            </div>
          </div>

          {/* 2nd block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className={`mb-2 font-medium ${footerTextColor}`}>Products</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <a
                  href="https://koi.eco"
                  target="_blank"
                  rel="noreferrer"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Koi
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://cranetool.org"
                  target="_blank"
                  rel="noreferrer"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  CRANE
                </a>
              </li>
            </ul>
          </div>

          {/* 4th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
            <h6 className={`mb-2 font-medium ${footerTextColor}`}>Company</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <Link
                  to="/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/impact/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Impact & Methodology
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/about/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Our Company
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/our-team/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Our Team
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/insights/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Insights &amp; Blog
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/case-studies/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Case Studies
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/news/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Rho Impact News
                </Link>
              </li>
              <li>
                <Link
                  to="/contact/"
                  className={`${footerTextColor} transition duration-150 ease-in-out`}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* 5th block */}
          <div className="sm:col-span-6 md:col-span-3 lg:col-span-3">
            <h6 className={`mb-2 font-medium ${footerTextColor}`}>
              Newsletter
            </h6>
            <p className={`mb-4 text-sm ${footerTextColor}`}>
              Get the latest Rho Impact and industry news delivered to your
              inbox.
            </p>
            <form onSubmit={onSubmit}>
              <div className="flex flex-wrap mb-4">
                <div className="w-full">
                  <label className="block text-sm sr-only" htmlFor="newsletter">
                    Email
                  </label>
                  <div className="relative flex items-center max-w-xs">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      className="w-full px-3 py-2 pr-12 text-sm text-gray-800 form-input"
                      placeholder="Your email"
                      required
                    />
                    <button
                      type="submit"
                      className="absolute inset-0 left-auto"
                      aria-label="Subscribe"
                    >
                      <span
                        className="absolute inset-0 right-auto w-px my-2 -ml-px bg-gray-300"
                        aria-hidden="true"
                      ></span>
                      <svg
                        className="flex-shrink-0 w-3 h-3 mx-3 text-blue-500 fill-current"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z"
                          fillRule="nonzero"
                        />
                      </svg>
                    </button>
                  </div>
                  {newsletterMessage && (
                    <p className={`mt-2 text-sm ${newsletterMessageColor}`}>
                      {newsletterMessage}
                    </p>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Bottom area */}
        <div
          className={`py-4 border-t border-gray-200 md:flex md:items-center md:justify-between md:py-8 ${footerHRColor}`}
        >
          {/* Social links */}
          <ul className="flex mb-4 md:order-1 md:ml-4 md:mb-0">
            <li>
              <a
                href="https://www.linkedin.com/company/rho-impact/"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center text-gray-600 transition duration-150 ease-in-out bg-white rounded-full shadow hover:bg-white-100"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="w-8 h-8 fill-current"
                >
                  <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                </svg>
              </a>
            </li>
            <li className="ml-4">
              <a
                href="https://github.com/rhoimpact"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center text-gray-600 transition duration-150 ease-in-out bg-white rounded-full shadow hover:bg-white-100"
                aria-label="GitHub"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 496 512"
                  className="w-8 h-8 fill-current"
                >
                  <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                </svg>
              </a>
            </li>
          </ul>

          {/* Copyrights note */}
          {year && (
            <div className="mr-4 text-sm text-gray-600">
              &copy; {year} Rho Impact, All rights reserved.
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
